import React from 'react';
import { DocumentNode, gql } from '@apollo/client';
import styles from './VendorProfile.module.scss';
import { Typography, FormLabel } from '@mui/material';
import { ProfileImage } from '../../../blocks/ProfileImage';
import type {
	VendorProfileVendorFragment,
	PermissionsModalOrganizationFragment,
	PermissionsModalOrganizationForGetContractWhereFragment,
} from '#types';
import classNames from 'classnames';

const vendorProfileVendorFragment = gql`
	fragment vendorProfileVendor on Organization {
		id
		name
		image
		services {
			name
			id
		}
	}
`;

export type VendorProfileProps = {
	vendor:
	| VendorProfileVendorFragment
	| PermissionsModalOrganizationFragment
	| PermissionsModalOrganizationForGetContractWhereFragment;
	className?: string;
};

type VendorProfilePropsWithFragments = React.FC<VendorProfileProps> & {
	fragments: {
		vendorProfileVendorFragment: DocumentNode;
	};
};

/**
 * Simple component for rendering the Vendor Profile
 */
export const VendorProfile: VendorProfilePropsWithFragments = ( {
	vendor,
	className,
} ) => (
	<div className={ classNames( styles.vendorProfile, className ) }>
		<ProfileImage
			styles={ styles }
			width='4rem'
			organization={ vendor }
			withIcon={ true } // so if there's no organization image...
		/>
		<div className={ styles.profileInfo }>
			<Typography variant='h5'>{ vendor.name }</Typography>
			<FormLabel>
				{ vendor.services
					?.filter( ( service ) => service !== null && service?.name )
					.map( ( service ) => service?.name )
					.filter( Boolean )
					.join( ', ' ) }
			</FormLabel>
		</div>
	</div>
);

VendorProfile.fragments = {
	vendorProfileVendorFragment,
};
